<template>
  <v-dialog v-model="localVisible" :max-width="maxWidth">
    <v-card :class="`alert-${type}`" class="alert-card">
      <v-card-title class="headline alert-title">
        <font-awesome-icon v-if="type === 'success'" icon="fa-solid fa-circle-check" class="alert-icon" />
        <font-awesome-icon v-if="type === 'error'" icon="fa-solid fa-circle-exclamation" class="alert-icon" />
        <font-awesome-icon v-if="type === 'warning'" icon="fa-solid fa-triangle-exclamation" class="alert-icon" />
        <font-awesome-icon v-if="type === 'info'" icon="fa-solid fa-circle-info" class="alert-icon" />
        {{ title }}
      </v-card-title>
      <v-card-text class="alert-content">
        <!-- Conditionally render message or slot content -->
        <div v-if="message">{{ message }}</div>
        <slot v-else></slot>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="close-btn" @click="closeDialog">关闭</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  components: {
    FontAwesomeIcon,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    message: { // Reintroduced message prop
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'success', // 可选值: 'success', 'error', 'warning', 'info'
    },
    maxWidth: { // New prop for max-width
      type: [String, Number],
      default: 400, // Default to 400px, can be overridden
    }
  },
  data() {
    return {
      localVisible: this.modelValue, // 使用本地变量存储 `modelValue` 的值
    };
  },
  watch: {
    modelValue(newVal) {
      this.localVisible = newVal; // 监听 `modelValue` 的变化，同步更新本地变量
    },
    localVisible(newVal) {
      this.$emit('update:modelValue', newVal); // 当本地变量变化时，通知父组件更新 `modelValue`
    }
  },
  methods: {
    closeDialog() {
      this.localVisible = false; // 关闭对话框时修改本地变量
    }
  }
};
</script>

<style scoped>
.alert-card {
  border-radius: 8px;
  text-align: center;
  padding: 16px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.alert-title {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4em;
  font-weight: bold;
  color: #fff;
}

.alert-icon {
  margin-right: 12px;
  font-size: 2em;
}

.alert-content {
  font-size: 1.1em;
  color: #fff;
  margin-top: 10px;
  text-align: left;
  overflow-y: auto;
  max-height: 300px;
}

.alert-success {
  background-color: #4caf50;
  border-left: 4px solid #388e3c;
}

.alert-error {
  background-color: #f44336;
  border-left: 4px solid #d32f2f;
}

.alert-warning {
  background-color: #FFB74D; /* Lighter orange background */
  border-left: 4px solid #FB8C00; /* Slightly darker orange border */
}

.alert-info {
  background-color: #2196f3;
  border-left: 4px solid #1976d2;
}

.v-btn.close-btn {
  background-color: #1976d2;
  color: #fff;
  font-weight: bold;
  text-transform: uppercase;
  padding: 6px 16px;
  border-radius: 4px;
}

.v-btn.close-btn:hover {
  background-color: #1565c0;
}
</style>
